module.exports = __webpack_public_path__ + "media/images/Dataset-793221bf106fc42c421a0453b356f04a.svg";